// Account Manager card on /uae (ID-130). Team photos stay placeholders until the owner supplies them.
export type AmCardProfile = {
  name: string;
  initials: string;
  photo: string | null;
  /** BCP-47 codes, shown in the visitor's language. */
  languages: readonly string[];
  teamPhotos: readonly (string | null)[];
};

export const UAE_AM_CARD: Readonly<AmCardProfile> = Object.freeze({
  name: 'Aygul Bykov',
  initials: 'AB',
  photo: '/images/am/aygul-bykov.jpg',
  languages: ['en', 'ru'],
  // TODO [AM_PHOTO_2], [AM_PHOTO_3], [AM_PHOTO_4]: set to the image paths once supplied.
  teamPhotos: [null, null, null],
});
